import { OFFER_API_DATA } from './reducer';

export const submitOfferPayload = state => {
  const offer = state.offers.get(OFFER_API_DATA);
  return JSON.stringify({
    offers: [
      {
        decision: 'ACCEPT',
        id: offer.id
      }
    ]
  });
};
